export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 90,
    slots: {
      default: 'opt',
    },
    visible: !that.disabled,
  },
  {
    field: 'custName',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    title: that.$l('INDEX.table_label_custName') || '客户',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'endCustName',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    title: that.$l('INDEX.order_form_label_endCustCode') || '终端客户',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'alertTypeName',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    title: that.$l('form_label_alertType') || '预警类型',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'alertFieldName',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    title: that.$l('form_label_alertField') || '预警字段',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'beforeTime',
    headerAlign: 'center',
    align: 'left',
    width: 200,
    title: that.$l('form_label_beforeTime') || '提前多少时间预警',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'recipient',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: that.$l('form_label_recipient') || '收件人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'ccTo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: that.$l('form_label_ccTo') || '抄送人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
